import { CheckCircle2, History } from "lucide-react";
import { fmtTime } from "@/components/ShareNotes";
import { useT } from "@/lib/publicI18n";

// V2+ public page: the previous version's resolved notes (with team replies) — what changed since the client's last listen.
export default function PreviousVersionNotes({ previous }) {
  const { t } = useT();
  if (!previous) return null;
  const notes = previous.resolved_notes || [];
  return (
    <div className="rounded-xl border border-emerald-500/25 bg-emerald-500/[0.04] p-3 space-y-2" data-testid="share-previous">
      <p className="text-xs font-semibold flex items-center gap-2 text-emerald-200"><History size={14} /> {t("prev_title", { v: previous.version })}
        <span className="text-muted-foreground font-normal">{t("prev_count", { n: notes.length })}{previous.path ? <> · <a href={previous.path} className="underline hover:text-foreground" data-testid="share-previous-link">{t("prev_relisten", { v: previous.version })}</a></> : ""}</span></p>
      {!notes.length && <p className="text-[11px] text-muted-foreground">{t("prev_none", { v: previous.version })}</p>}
      {notes.length > 0 && (
        <ul className="space-y-1.5" data-testid="share-previous-list">
          {notes.map((n) => (
            <li key={n.id} className="rounded-lg border border-emerald-500/20 bg-card/50 px-3 py-2 text-xs" data-testid={`share-previous-note-${n.id}`}>
              <div className="flex gap-2 items-start">
                <span className="font-mono text-emerald-300 shrink-0">{fmtTime(n.time)}</span>
                <div className="flex-1 min-w-0"><span className="font-semibold">{n.author}</span><p className="mt-0.5 break-words text-muted-foreground">{n.text}</p></div>
                <span className="inline-flex items-center gap-1 text-emerald-300 shrink-0"><CheckCircle2 size={12} /> {t("resolved")}</span>
              </div>
              {n.reply?.text && <p className="mt-1.5 ml-4 border-l-2 border-cyan-500/50 pl-2 italic text-cyan-100/90 break-words"><span className="not-italic font-semibold text-cyan-300">↳ {t("team")} · {n.reply.author}</span> · {n.reply.text}</p>}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
